import { useFormikContext } from 'formik';
import { TimePicker, ErrorContainer, LabelComponent } from 'components';
import dayjs from 'dayjs';

interface StartTimeProps {
  disabled: boolean;
}

export const StartTime = ({ disabled }: StartTimeProps) => {
  const formik = useFormikContext<{
    startTimeOfEncounter: string | null;
  }>();

  return (
    <>
      <LabelComponent mandatory text="Start Time" />
      <TimePicker
        withGradient
        disabled={disabled}
        name={'startTimeOfEncounter'}
        onChange={(time: string) =>
          formik.setFieldValue('startTimeOfEncounter', time).then(() => {
            formik.setFieldTouched('startTimeOfEncounter', true);
          })
        }
        onBlur={() => formik.setFieldTouched('startTimeOfEncounter', true)}
        value={
          dayjs(formik.values.startTimeOfEncounter, ['hh:mm A', 'HH:mm:ss'], true).isValid()
            ? dayjs(formik.values.startTimeOfEncounter, ['hh:mm A', 'HH:mm:ss'], true).format(
                'HH:mm:ss'
              )
            : null
        }
        showIcon={true}
      />
      <ErrorContainer
        visible={formik.touched.startTimeOfEncounter && formik.errors.startTimeOfEncounter}
        errors={formik.errors}
        name="startTimeOfEncounter"
      />
    </>
  );
};
